import { blogRedirectTarget } from '~/constants/blogRedirects'

/**
 * 301 for blog posts merged into another URL (constants/blogRedirects.ts).
 *
 * Route middleware rather than a server one so it also catches in-app
 * navigation to an old slug: on SSR navigateTo answers with the 301 itself, on
 * the client it swaps the route before the missing article is fetched.
 */
export default defineNuxtRouteMiddleware((to) => {
  const target = blogRedirectTarget(String(to.params.slug ?? ''))
  if (target) {
    return navigateTo(target, { redirectCode: 301, replace: true })
  }
})
